// extracted by mini-css-extract-plugin
module.exports = {"ecBreadcrumbSection":"BreadcrumbSection_ecBreadcrumbSection__Xj6ym","showScale":"BreadcrumbSection_showScale__Z_1s1"};